import { ThemeConfig } from "../config/theme.config";
import ScrollToTop from "../wrapper/scrollToTop";
import { Box, Button, Divider, Grid, Stack, Typography } from "@mui/material";
import { AnimationOnScroll } from "react-animation-on-scroll";
import { Footer, NavBar } from "../components";
import ServiceTitleSectionIconFirst from "../components/ServiceTitleSectionIconFirst";
import { ScrollToTopButton } from "../components/scrollToTopButton";
import ContactConsultantButton from "../components/contactConsultantButton";
import { QuestionAccordion } from "../components/questionAccordion";
import { ElectronicSignaturesQuestions } from "../const/AccordionQuestions";
import { electronicSignaturesProcessSteps } from "../const/electronicSignaturesProcessSteps";
import { electronicSignaturesBenefits } from "../const/electronicSignaturesBenefits";
import { imageZone } from "./ServicesScreen";

const firmasBenefitTitleSx = {
   fontFamily: "ExtraBold",
   fontSize: { xs: "26px", lg: "30px" },
   color: "#162C44",
   textAlign: { xs: "center", md: "left" },
   letterSpacing: 0.5,
   lineHeight: 1.2,
};

const firmasBenefitBodySx = {
   fontFamily: "'Open Sans', sans-serif",
   fontWeight: 400,
   fontSize: { xs: "20px", lg: "24px" },
   lineHeight: 1.4,
   textAlign: "justify",
   color: "#162C44",
};

const firmasDescriptionZone = (benefit, i) => (
   <Box
      sx={{
         flexDirection: "column",
         flex: 1,
         px: { xs: 1, sm: 6, md: 0 },
         py: { xs: 1, sm: 3, md: 0 },
      }}
   >
      <Grid
         container
         direction={i % 2 === 0 ? "row" : "row-reverse"}
         spacing={{ lg: 1 }}
         sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >
         <Grid item xs={12} sx={{ maxWidth: { lg: "450px" } }}>
            <Box sx={{ px: { sm: 2, md: 4, lg: 0 } }}>
               <Typography sx={firmasBenefitTitleSx}>{benefit.title}</Typography>
               <AnimationOnScroll animateIn="animate__slideInLeft" animateOnce animatePreScroll={false} duration={0.75}>
                  <Divider sx={{ borderBottomWidth: "4px", bgcolor: "#162c44", my: 1 }} />
                  <Typography sx={firmasBenefitBodySx}>{benefit.description}</Typography>
               </AnimationOnScroll>
            </Box>
         </Grid>
      </Grid>
   </Box>
);

export const ElectronicSignatures = () => {
   return (
      <ThemeConfig>
         <ScrollToTop>
            <NavBar />
            <Box position={"relative"} sx={{ mt: -14, pt: 18 }}>
               <Box position={"absolute"} top={0} width={"100%"} zIndex={-1}>
                  <Box
                     sx={{
                        backgroundImage:
                           "url(https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/firmas-electronicas/firmas-electronicas-banner-1.png)",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        width: "100%",
                        height: { xs: "450px", md: "615px", lg: "700px" },
                     }}
                  />
               </Box>

               <ServiceTitleSectionIconFirst
                  icon={
                     "url(https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/iconos/ICONOS+de+m%C3%B3dulos+LECOSY_firmas+electr%C3%B3nicas-azul.svg)"
                  }
                  title={"Firmas electrónicas"}
                  phrase="Garantice la fecha cierta y materialidad con el uso de la tecnología."
               />
            </Box>

            <Box
               mt={{ md: 0, lg: -10 }}
               position={"relative"}
               bgcolor={"transparent"}
               zIndex={2}
               sx={{
                  backgroundImage: `url(https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/curvedBg.png)`,
                  backgroundSize: { md: "0% 0%", lg: "100% 135%" },
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  px: { sm: 4, md: 0 },
                  pb: 0,
                  py: { xs: 4, lg: 4 },
               }}
            >
               <Box
                  px={{ xs: 4, sm: 6, md: 10 }}
                  pt={{ xs: 4, lg: 12 }}
                  pb={{ xs: 2, md: 4 }}
                  sx={{ maxWidth: { lg: "1200px" }, mx: { lg: "auto" } }}
               >
                  <Typography
                     textAlign={"center"}
                     fontFamily={"regular"}
                     fontSize="25px"
                     sx={{ lineHeight: 1.3, color: "#162c44", mx: "auto" }}
                  >
                     La adopción de tecnología en la formalización de actos jurídicos 
                     <br />
                     <Typography
                        component="span"
                        fontFamily={"ExtraBold"}
                        fontSize="25px"
                        sx={{ lineHeight: 1.3, color: "#4778A5" }}
                     >
                        permite reducir costos operativos;
                     </Typography>
                     {" "}además,{" "}
                     <Typography
                        component="span"
                        fontFamily={"ExtraBold"}
                        fontSize="25px"
                        sx={{ lineHeight: 1.3, color: "#162c44" }}
                     >
                        incrementa la
                     </Typography>
                     <br />
                     <Typography
                        component="span"
                        fontFamily={"ExtraBold"}
                        fontSize="25px"
                        sx={{ lineHeight: 1.3, color: "#162c44" }}
                     >
                        productividad, eficiencia y certeza legal
                     </Typography>
                     {" "}de los acuerdos celebrados.
                  </Typography>
               </Box>

               <Grid
                  container
                  spacing={{ xs: 4, md: 6 }}
                  alignItems="center"
                  px={{ xs: 4, sm: 6, md: 10 }}
                  py={{ xs: 4, sm: 6, md: 6, lg: 8 }}
                  sx={{ maxWidth: { lg: "1200px" }, mx: { lg: "auto" } }}
               >
                  <Grid
                     item
                     xs={12}
                     md={6}
                     sx={{ display: "flex", alignItems: "center" }}
                  >
                     <Typography
                        sx={{
                           color: "#162c44",
                           fontSize: "18px",
                           textAlign: "justify",
                           lineHeight: 1.3,
                           width: "100%",
                        }}
                        pr={{ md: 4, lg: 6 }}
                     >
                        En un entorno cada vez más dinámico, las organizaciones requieren{" "}
                        <strong>soluciones tecnológicas alineadas con el marco jurídico vigente</strong> que les
                        permitan firmar documentos y contratos de manera segura, incluso a través de fronteras. Esto
                        facilita la aceleración de transacciones, la formalización de operaciones comerciales y la
                        optimización integral de los procesos legales y administrativos.
                     </Typography>
                  </Grid>
                  <Grid
                     item
                     xs={12}
                     md={6}
                     sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
                  >
                     <Box
                        sx={{
                           width: { xs: "100%", md: "478px" },
                           maxWidth: "478px",
                           height: { xs: "auto", md: "310px" },
                           aspectRatio: { xs: "478 / 310", md: "unset" },
                           mx: { xs: "auto", md: 0 },
                           borderRadius: { xs: 2, md: 3 },
                           backgroundImage:
                              "url(https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/firmas-electronicas/huella-digital-firma-electronica.png)",
                           backgroundSize: "cover",
                           backgroundPosition: "center",
                           backgroundRepeat: "no-repeat",
                        }}
                     />
                  </Grid>
               </Grid>
            </Box>

            <Box width={"100%"} sx={{ overflow: "hidden" }}>
               <Box
                  sx={{
                     width: "100%",
                     minHeight: { xs: "auto", md: "217px" },
                     display: "flex",
                     alignItems: "center",
                     justifyContent: "center",
                     px: { xs: 3, md: 6 },
                     py: { xs: 4, md: 5 },
                     bgcolor: "#334D62",
                  }}
               >
                  <Typography
                     textAlign={"center"}
                     fontFamily={"bold"}
                     fontSize="26px"
                     sx={{
                        lineHeight: 1.35,
                        maxWidth: { md: "1100px" },
                        color: "#E8ECEF",
                     }}
                  >
                     Con Lecosy, firme electrónicamente sus contratos o cualquier otro documento de manera segura,
                     eficiente y alineada con la legislación vigente.
                  </Typography>
               </Box>

               <Grid container spacing={0} alignItems="stretch" width="100%">
                  <Grid item xs={12} md={6} sx={{ display: "flex" }}>
                     <Stack spacing={0} width="100%" flex={1}>
                        <Box
                           sx={{
                              width: "100%",
                              height: { xs: "auto", md: "436px" },
                              aspectRatio: { xs: "730 / 436", md: "unset" },
                              display: "block",
                              lineHeight: 0,
                              backgroundImage:
                                 "url(https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/firmas-electronicas/hombre-celular.png)",
                              backgroundSize: "cover",
                              backgroundPosition: "center",
                              backgroundRepeat: "no-repeat",
                           }}
                        />
                        <Box
                           sx={{
                              width: "100%",
                              bgcolor: "#162C44",
                              px: { xs: 3, md: 5, lg: 8 },
                              py: { xs: 3, md: 4 },
                              flex: 1,
                           }}
                        >
                           <Typography
                              fontFamily={"bold"}
                              color={"#FFFFFF"}
                              sx={{ fontSize: "32px", lineHeight: 1.2, mb: 2 }}
                           >
                              ¿Es legal firmar contratos de manera electrónica en México?
                           </Typography>
                           <Typography
                              fontFamily={"regular"}
                              color={"#FFFFFF"}
                              sx={{ fontSize: "16px", lineHeight: 1.4, textAlign: "justify" }}
                           >
                              En el contexto de la legislación mexicana, la firma electrónica tiene plena validez
                              jurídica, tal como lo establecen el Código Civil Federal, el Código de Comercio y
                              disposiciones análogas. La e.firma (firma electrónica avanzada) permite firmar documentos
                              de manera segura, sin importar si los firmantes son nacionales o extranjeros.
                           </Typography>
                        </Box>
                     </Stack>
                  </Grid>
                  <Grid item xs={12} md={6} sx={{ display: "flex" }}>
                     <Box
                        sx={{
                           position: "relative",
                           width: "100%",
                           flex: 1,
                           minHeight: { xs: "auto", md: "100%" },
                           bgcolor: "#5C6C7C",
                           px: { xs: 3, md: 5, lg: 8 },
                           py: { xs: 4, md: 6 },
                           display: "flex",
                           flexDirection: "column",
                           overflow: "hidden",
                        }}
                     >
                        <Box
                           sx={{
                              position: "absolute",
                              right: 0,
                              bottom: 0,
                              width: { xs: "200px", md: "350px" },
                              height: { xs: "200px", md: "350px" },
                              backgroundImage:
                                 "url(https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/gobierno-corporativo/fondos/Fondo-Seccion-3-derecho.png)",
                              backgroundRepeat: "no-repeat",
                              backgroundSize: "contain",
                              backgroundPosition: "bottom right",
                              opacity: 0.15,
                              pointerEvents: "none",
                           }}
                        />
                        <Typography
                           fontFamily={"bold"}
                           color={"#FFFFFF"}
                           sx={{
                              fontSize: "40px",
                              lineHeight: 1.2,
                              mb: 3,
                              position: "relative",
                              zIndex: 1,
                           }}
                        >
                           ¿Qué es la firma electrónica?
                        </Typography>
                        <Typography
                           fontFamily={"regular"}
                           color={"#FFFFFF"}
                           sx={{
                              fontSize: "16px",
                              lineHeight: 1.4,
                              textAlign: "justify",
                              position: "relative",
                              zIndex: 1,
                           }}
                        >
                           Para explorar el marco jurídico de la firma electrónica, es fundamental comprender su
                           definición:
                           <br />
                           <br />
                           “Es un conjunto de datos en forma electrónica consignados en un mensaje de datos, o adjuntados
                           o lógicamente asociados al mismo por cualquier tecnología, que son utilizados para identificar
                           al firmante en relación con el mensaje de datos e indicar que el firmante aprueba la
                           información contenida en el mensaje de datos, y que produce los mismos efectos jurídicos que
                           la firma autógrafa, siendo admisible como prueba en juicio.”
                           <br />
                           <br />
                           Artículo 89 del Código de Comercio.
                           <br />
                           <br />
                           En otras palabras, es un conjunto de datos que se adjuntan a un mensaje electrónico, cuyo
                           propósito es identificar al emisor del mensaje como autor legítimo de este, tal y como si se
                           tratara de una firma autógrafa.
                        </Typography>
                     </Box>
                  </Grid>
               </Grid>
            </Box>

            <Box bgcolor={"#FFFFFF"} py={{ xs: 6, md: 10 }} px={{ xs: 3, md: 8, lg: 10 }}>
               <Box textAlign={"center"} mx={"auto"} maxWidth={{ md: "900px" }}>
                  <Typography
                     component="div"
                     fontFamily={"bold"}
                     color={"#162c44"}
                     sx={{ fontSize: "40px", lineHeight: 1.2 }}
                  >
                     <Box component="span" display="block">
                        ¿Cómo funciona el{" "}
                        <Box component="span" sx={{ fontFamily: "ExtraBold" }}>proceso de firma</Box>
                     </Box>
                     <Box
                        component="span"
                        display="inline-block"
                        sx={{
                           borderBottom: 5,
                           borderColor: "#4778A5",
                           pb: 1,
                        }}
                     >
                        en nuestro sistema?
                     </Box>
                  </Typography>
               </Box>

               <Box
                  sx={{
                     mt: { xs: 4, md: 6 },
                     display: "grid",
                     gridTemplateColumns: {
                        xs: "1fr",
                        sm: "repeat(2, 1fr)",
                        lg: "repeat(5, 1fr)",
                     },
                     gap: { xs: 2, md: 3 },
                     maxWidth: "1440px",
                     mx: "auto",
                     alignItems: "stretch",
                  }}
               >
                  {electronicSignaturesProcessSteps.map((step) => (
                     <Box
                        key={step.title}
                        sx={{
                           border: "1.5px solid #3D8FD6",
                           borderRadius: "10px",
                           bgcolor: "#FFFFFF",
                           pt: "24px",
                           pr: "24px",
                           pb: "24px",
                           pl: "14px",
                           minHeight: { md: "333px" },
                           height: "100%",
                           display: "flex",
                           flexDirection: "column",
                           alignItems: "center",
                           gap: "16px",
                           boxShadow: "0 0 14px 1px #5AAAE8",
                        }}
                     >
                        <Box
                           sx={{
                              width: "64px",
                              height: "64px",
                              backgroundImage: step.icon,
                              backgroundRepeat: "no-repeat",
                              backgroundPosition: "center center",
                              backgroundSize: "contain",
                           }}
                        />
                        <Typography
                           fontFamily={"ExtraBold"}
                           color={"#162c44"}
                           sx={{
                              fontSize: "16px",
                              lineHeight: 1.3,
                              textAlign: "center",
                              minHeight: "calc(16px * 1.3 * 2)",
                           }}
                        >
                           {step.title}
                        </Typography>
                        <Typography
                           fontFamily={"regular"}
                           color={"#5D6D7C"}
                           sx={{ fontSize: "16px", lineHeight: 1.4, textAlign: "center" }}
                        >
                           {step.description}
                        </Typography>
                     </Box>
                  ))}
               </Box>
            </Box>

            <Box
               sx={{
                  backgroundImage:
                     "url(https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/inicio/background/Fondo-seccion-4.jpg)",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundAttachment: "fixed",
                  py: { xs: 8, md: 12 },
                  px: { xs: 3, md: 10 },
                  textAlign: "center",
               }}
            >
               <Typography
                  fontFamily={"bold"}
                  sx={{ color: "white", fontSize: "26px", lineHeight: 1.3, maxWidth: "900px", mx: "auto" }}
               >
                  Quiero el módulo Firmas Electrónicas para mi empresa.
               </Typography>
               <Box
                  sx={{
                     width: { xs: "85%", sm: "90%", md: "723px" },
                     maxWidth: "723px",
                     height: "2px",
                     bgcolor: "#4778A5",
                     mx: "auto",
                     my: { xs: 2, md: 2.5 },
                     boxShadow: "0 0 19.8px 1px #4778A5",
                  }}
               />
               <Box display={"flex"} justifyContent={"center"} pt={{ xs: 1, md: 2 }}>
                  <Button
                     href="/contacto"
                     sx={{
                        bgcolor: "#4778A5",
                        px: 3,
                        py: 1.5,
                        borderRadius: 2,
                        "&:hover": { bgcolor: "#3d6890" },
                     }}
                  >
                     <Typography fontFamily={"bold"} color="white" sx={{ lineHeight: 1.2 }}>
                        Solicitar información
                     </Typography>
                  </Button>
               </Box>
            </Box>

            <Stack
               direction={"column"}
               spacing={3}
               p={{ xs: 3, lg: 10 }}
               sx={{
                  backgroundImage:
                     "url(https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/Fondo+beneficios.png)",
                  backgroundPosition: "center top",
                  backgroundSize: "cover",
                  backgroundRepeat: "no-repeat",
               }}
            >
               <Box display={"flex"} justifyContent={"center"} px={{ xs: 1, sm: 4, lg: "auto" }}>
                  <Typography
                     component="div"
                     textAlign={"center"}
                     color={"#162c44"}
                     fontFamily={"bold"}
                     fontSize={{ xs: "40px", lg: "44px" }}
                     sx={{ lineHeight: 1.3, pt: 6, mx: 1 }}
                  >
                     5 Beneficios que logrará con la implementación
                     <br />
                     de nuestro Módulo Firmas Electrónicas
                     <Box
                        sx={{
                           borderBottom: 5,
                           borderColor: "#162C44",
                           width: { xs: "220px", sm: "280px", md: "320px" },
                           mx: "auto",
                           mt: 1.5,
                        }}
                     />
                  </Typography>
               </Box>
               <Grid container>
                  {electronicSignaturesBenefits.map((benefit, i) => {
                     return (
                        <Grid
                           item
                           md={12}
                           key={benefit.title}
                           sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              alignSelf: "center",
                           }}
                        >
                           <Box
                              columnGap={{ sm: 0, md: 4, lg: 0 }}
                              id={`section${i + 1}`}
                              sx={{
                                 display: "flex",
                                 flexDirection: {
                                    xs: "column",
                                    md: i % 2 === 0 ? "row" : "row-reverse",
                                 },
                                 alignItems: { md: "center" },
                                 justifyContent: "center",
                                 alignSelf: "center",
                                 textAlign: "justify",
                                 py: { xs: 4, sm: 2, md: 0 },
                                 px: { xs: 1, sm: 4 },
                                 maxWidth: { md: "1000px" },
                                 minWidth: { lg: "1240px" },
                                 color: "#162C44",
                                 fontFamily: "regular",
                              }}
                           >
                              {firmasDescriptionZone(benefit, i)}
                              {imageZone(benefit, i % 2 === 0)}
                           </Box>
                        </Grid>
                     );
                  })}
               </Grid>
               <Box
                  display={"flex"}
                  justifyContent={"flex-end"}
                  sx={{ pr: { xs: "30px", sm: "54px", md: "65px", lg: "58px" } }}
               >
                  <ContactConsultantButton />
               </Box>
            </Stack>

            <Box
               sx={{
                  backgroundImage:
                     "url(https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/firmas-electronicas/fondo-firmas-1.png)",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  py: { xs: 8, md: 12 },
                  px: { xs: 3, md: 10 },
               }}
            >
               <Typography
                  sx={{
                     color: "white",
                     textAlign: "center",
                     fontSize: "20px",
                     lineHeight: 1.4,
                     maxWidth: { md: "900px" },
                     mx: "auto",
                  }}
               >
                  <Box component="span" sx={{ fontFamily: "regular" }}>
                     Firmar documentos electrónicamente{" "}
                  </Box>
                  <Box component="span" sx={{ fontFamily: "bold" }}>
                     eficienta los procesos de gestión y facilita las relaciones comerciales.
                  </Box>
               </Typography>
            </Box>

            <Box
               sx={{
                  position: "relative",
                  minHeight: { md: "570px" },
                  backgroundImage:
                     "url(https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/Figures/Figura-5.png)",
                  backgroundSize: { xs: "0% 0%", md: "55% 100%" },
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "bottom right",
               }}
            >
               <Box
                  height={"100%"}
                  width={"400px"}
                  position={"absolute"}
                  right={0}
                  sx={{
                     backgroundImage: "url(https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/Capa_1.png)",
                     backgroundSize: "contain",
                     backgroundRepeat: "no-repeat",
                     backgroundPosition: "center",
                     display: { xs: "none", sm: "none", md: "inline" },
                  }}
               />
               <Typography
                  fontFamily={"bold"}
                  color={"primary"}
                  sx={{
                     px: { xs: 2, md: 10 },
                     pt: { md: 8, lg: 20 },
                     fontSize: "40px",
                  }}
               >
                  Preguntas frecuentes
               </Typography>
               {QuestionAccordion(ElectronicSignaturesQuestions, true)}
            </Box>

            <Footer />
            {ScrollToTopButton(window)}
         </ScrollToTop>
      </ThemeConfig>
   );
};
